// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"64e26c21","777":"f8eaee04"}[chunkId] + ".chunk.js";
};